import axiosClient from './axiosClient';
import { IApiBaseResponse } from '~/utils/interface/common';

// Interfaces
export interface ISmsConversation {
  id: string;
  phoneNumber: string;
  contactName: string | null;
  contactId: string | null;
  jobId: string | null;
  lastMessage: string;
  lastMessageAt: string;
  unreadCount: number;
  status: 'active' | 'archived';
  assignedTo: {
    id: string;
    name: string;
  } | null;
  createdAt: string;
}

export interface ISmsMessage {
  id: string;
  conversationId: string;
  direction: 'inbound' | 'outbound';
  fromNumber: string;
  toNumber: string;
  body: string;
  status: 'queued' | 'sent' | 'delivered' | 'undelivered' | 'failed';
  sentAt: string;
  deliveredAt: string | null;
  createdAt: string;
}

export interface IGetConversationsParams {
  status?: 'active' | 'archived';
  page?: number;
  limit?: number;
  search?: string;
  assignedTo?: string;
  salesRep?: string;
}

export interface IGetConversationsResponse {
  conversations: ISmsConversation[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface IGetMessagesResponse {
  conversation: {
    id: string;
    phoneNumber: string;
    contactName: string | null;
  };
  messages: ISmsMessage[];
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
}

export interface ISendSmsPayload {
  to: string;
  body: string;
  conversationId?: string;
  contactId?: string;
  jobId?: string;
}

export interface IUpdateConversationPayload {
  status?: 'active' | 'archived';
  assignedTo?: string;
  unreadCount?: number;
}

export interface IContactDetails {
  id: string;
  name: string;
  phone: string;
  email: string | null;
  address: string | null;
  assignedTo: {
    id: string;
    name: string;
  } | null;
  createdAt: string;
  optInStatus: 'opted_in' | 'opted_out';
}

const smsApi = {
  getConversations(params: IGetConversationsParams) {
    return axiosClient.get<IApiBaseResponse<IGetConversationsResponse>>(
      '/api/sms/conversations',
      { params }
    );
  },

  getMessages(conversationId: string, params?: { page?: number; limit?: number }) {
    return axiosClient.get<IApiBaseResponse<IGetMessagesResponse>>(
      `/api/sms/conversations/${conversationId}/messages`,
      { params }
    );
  },

  sendSms(data: ISendSmsPayload) {
    return axiosClient.post<IApiBaseResponse<any>>(
      '/api/sms/send',
      data
    );
  },

  updateConversation(conversationId: string, data: IUpdateConversationPayload) {
    return axiosClient.patch<IApiBaseResponse<any>>(
      `/api/sms/conversations/${conversationId}`,
      data
    );
  },

  getContactDetails(conversationId: string) {
    return axiosClient.get<IApiBaseResponse<IContactDetails>>(
      `/api/sms/conversations/${conversationId}/contact`
    );
  },
};

export default smsApi;
